import { FC } from 'react';

interface ViewAllGamesGridSkeletonProps {
  categoryName: string;
}

export const ViewAllGamesGridSkeleton: FC<ViewAllGamesGridSkeletonProps> = ({ categoryName }) => {
  return (
    <div className="view-all-games-grid__loading" data-testid="view-all-games-grid-skeleton">
      <div className="view-all-games-grid__skeleton-container">
        {/* Create 6 skeleton tiles that mimic the actual game grid structure */}
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="view-all-games-grid__skeleton-tile">
            {/* Mimic the 3-section structure: first_full_width_tile, second_full_width_tile, third_full_width_tile_block */}
            <div className="view-all-games-grid__skeleton-section">
              {Array.from({ length: 4 }, (_, j) => (
                <div key={j} className="view-all-games-grid__skeleton view-all-games-grid__skeleton--animated" />
              ))}
            </div>
            <div className="view-all-games-grid__skeleton-section">
              {Array.from({ length: 4 }, (_, j) => (
                <div key={j} className="view-all-games-grid__skeleton view-all-games-grid__skeleton--animated" />
              ))}
            </div>
            <div className="view-all-games-grid__skeleton-section">
              {Array.from({ length: 4 }, (_, j) => (
                <div key={j} className="view-all-games-grid__skeleton view-all-games-grid__skeleton--animated" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
